// src/Pages/Assets/futuresComponentes/PositionsList.jsx
import React from "react";
import { Box, Grid, LinearProgress, Paper, Typography } from "@mui/material";
import PositionCard from "./PositionCard";

export default function PositionsList({
  rows,
  loading,
  onClose,
  onCancel,
  brand,
  maxHeight = "58vh",
}) {
  return (
    <Box sx={{ maxHeight, overflowY: "auto", pr: 1 }}>
      {loading && (
        <LinearProgress
          sx={{
            height: 2,
            mb: 1,
            "& .MuiLinearProgress-bar": { bgcolor: brand },
          }}
        />
      )}
      {!loading && (!rows || rows.length === 0) ? (
        <Paper
          variant="outlined"
          sx={{ p: 3, textAlign: "center", borderRadius: 2 }}
        >
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            No open positions
          </Typography>
        </Paper>
      ) : (
        <Grid container spacing={1.2}>
          {rows.map((row) => (
            <Grid item xs={12} md={6} key={row._id}>
              <PositionCard row={row} onClose={onClose} onCancel={onCancel} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}
